import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
//MUI
import { Box, Checkbox, Grid, Stack } from "@mui/material";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { theme } from '../../assets/themes';
import UButton from "../../components/mui/UButton";
import UAuthButton from "../../components/mui/UAuthButton";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UConfirmDialog from "../../components/mui/UConfirmDialog";
import UAlertDialog from "../../components/mui/UAlertDialog";
import UPopupForm from "../../components/mui/UPopupForm";
import UTable from "../../components/mui/UTable";

import { API, } from "../../config";
import { fni18n } from "../../services/commonService";
import {
    getAPI
    ,postAPI
    ,putAPI
    ,deleteAPI
} from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";

import USelectBox from "../../components/mui/USelectBox";
import { makeStyles } from "@material-ui/core/styles";
import StoreModify from "./StoreModify";


export default function StorePage(){
	const { t } = useTranslation();
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const columns = [
        { 
            field: 'id',
            headerName: '번호',
            hide: true,
        },
        {
            field: 'storeCd',
            headerName: '지점',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
            hide: true,
        },
        {
            field: 'storeNm',
            headerName: '지점명',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'brandCd',
            headerName: '브랜드번호',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'brandNm',
            headerName: '브랜드명',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'useYn',
            headerName: '사용여부',
            width: "11%",
            editable: false,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if(params.value==true){
                    return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
                }else {
                    return <Checkbox checked={false} disabled/>
                }
            }
            
        },
        {
            field: 'description',
            headerName: '설명',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'button',
            headerName: '설정',
            sortable: false,
            width: "11%",
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) =>
            (
                <UButton
                variant="outlined"
                onButtonClick={()=>handleRowSelect(params.rows)}
                menuFrom={location.pathname}
                >
                    보기
                </UButton>
            ),
        },
        {
            field: "delete",
            headerName: "삭제",
            sortable: false,
            width: 100,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <UButton
                    variant="outlined"
                    onButtonClick={() => handleDelete(params.rows)}
                    menuFrom={location.pathname}
                >
                    삭제
                </UButton>
            ),
        },
    ];

    const useStyles = makeStyles({
        table: {
            "& .MuiTableCell-root": {
                border: "1px solid #EAEAEA",
                borderTop: "1px solid #EAEAEA",
            }
        },
        header:{
            fontWeight:"bold",
            "& .MuiTableCell-root": {
                // width:195,
            }
        },
        cellTitle:{
            backgroundColor:theme.custom.appbarBgColor,            
        },
        cell:{
            padding:5
        }
    });
    const location = useLocation();

    const [stores, setStore] = useState([]);   //지점 
    const [brands, setBrands] = useState([]);   //브랜드
    const [retailers, setRetailers] = useState([]);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [search, setSearch] = useState({
        // brandCd: "ALL",  //브랜드
        // store: "N/A", //지점
    });
    const [list, setList] = useState([]);

    const [confirmPopupOpen, setConfirmPopupOpen] = useState(false); // confirm dialog
    const [errorPopupOpen, setErrorPopupOpen] = useState(false); // error dialog
    const [errorMsg, setErrorMsg] = useState(""); // api error message
    const [confirmMsg, setConfirmMsg] = useState(""); // api error message
    const [confirmEvent, setConfirmEvent] = useState(""); 
    const [ formOpen, setFormOpen ] = useState(false);
    const [modify, setModify] = useState({
        branch : "",
        storeCd : "",
        storeNm : "",
        useYn : true,
        description : "",
        chkCreate : "",
    });

    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
        try {
            await Promise.all([
                loadComboBoxBranchGroup(),
                loadComboBoxBranch()
            ]);
        } catch (e) {
            console.error('초기 로딩 실패:', e.message);
        }
        };
        getLoadData();
    }, []);

    useEffect(() => {
        if (!isFirstLoad) return;
        if (search.storeCd) {
            onButtonClick("조회");
            setIsFirstLoad(false);
        }
    }, [search]);
    
     const clearSearchVal = ()=>{
        setSearch({
            ...search,
            ['storeCd']: 'N/A',
        });
        setBrands([]);
    }

    // 콤보박스 데이터
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxBranch = async (param) => {
        try{
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.storeCd,
                    name: m.storeNm,
                })
            );
            setStore(_inputData);
            if (_inputData.length > 0){
                await loadComboBoxBrand(_inputData[0].cd);
            } else{
                clearSearchVal()
            }
        }catch(e){
            console.error(e.message);
        }
    }; 
    const loadComboBoxBrand = async (branch) => {
        try{
            const res = await getAPI(API.COMMON.BRAND, { userId: userLoginId, branch: branch});
            const _inputData = res.data.result.map((m) => ({
                    cd: m.brandCd,
                    name: m.brandNm,
                })
            );
            setSearch({
                ...search,
                ['storeCd'] : branch,
            })
            setBrands(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    const handleConfirmOpen = (e) => {
        setConfirmPopupOpen(true);
        setConfirmEvent(e)
    };
    const handleConfirmClose = () => {
        setConfirmPopupOpen(false);
    };
    /**처리성공 시 팝업 띄우지 않는다. 실패 시에만 팝업 띄운다 */
    /**처리실패 시에는 창 닫지 않는다. 성공 시에만 자동 closed.*/
    const handelConfirmEvent = async () => {
        try{
            if(confirmEvent==="put"){
                await putAPI(API.SYSTEM.STORE, modify).then((res) =>{
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            }else if(confirmEvent==="post"){
                await postAPI(API.SYSTEM.STORE, modify).then((res) =>{
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            }else if(confirmEvent==="delete"){
                await deleteAPI(API.SYSTEM.STORE, modify).then((res) =>{
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            }
        }catch (error) {
            console.log(error)
        } finally {
            handleConfirmClose();
            await onButtonClick("조회");
        }
    };

    const handleErrorOpen = () => {
        setErrorPopupOpen(true);
    };
    const handleErrorClose = () => {
        setErrorPopupOpen(false);
    };

    const handleRowSelect = (row) => {
        setModify({
            branch : row.storeCd,
            storeCd : row.brandCd,
            storeNm : row.brandNm,
            useYn : row.useYn,
            description : row.description,
            chkCreate : row.storeNm||"",
        })
        handleFormOpen();   //상세팝업
    }

    const handleFormOpen = () => {
        setFormOpen(true);
    };
    const handleFormClose = () => {
        setFormOpen(false);
    };

    //DataGrid에서 row 선택 시 
    function onSelectedRow(row){

    };
    const onSelectedRows = (e, row) => {
    };
    //value 속성으로만 값을 컨트롤 할 수 있어서 
    //onChange를 써서 element를 수정할 수 있는 상태로 만듦
    const onModifyChange = (e) => {
        const { name, value } = e.target;
        setModify({
            ...modify,
            [name]: value,
        });
    };

    //검색조건 값 변경되었을 때
    const onSearchChange = async (e) => {
        const {name, value} = e.target;
        setSearch({
            ...search,
            [name] :value==='ALL'?'':value,
        })
        if (name === "bizTy") {
            loadComboBoxBranch(value);
        }
        if(name=='storeCd'){
            await loadComboBoxBrand(value);
        }
    }

    const onCheckboxChange = (e) => {
        setModify({
          ...modify,
          [e.target.name]: e.target.checked,
        });
    };
    
    async function onButtonClick(dvsn){
        if(dvsn==="조회"){
            await getAPI(API.SYSTEM.STORE, search).then((res) =>{
                if (res.data.code === 200) {
                    setList(res.data.result);
                } else {
                    setErrorMsg(t("처리가 실패하였습니다"))
                    handleErrorOpen();
                }
            })
        }else if(dvsn==="추가"){
            const row = ({
                branch : "",
                storeCd : "",
                storeNm : "",
                useYn : true,
                description : "",
                chkCreate : "",
            });
            handleRowSelect(row);
        }else {
            setErrorMsg(t("알 수 없는 오류가 발생하였습니다"))
            handleErrorOpen();
        }
    };
    const onSave = async (e) => { 
        let flag;
        await getAPI(API.SYSTEM.STORE+'/duplicateCheck', modify).then((res) =>{
            flag=res.data;
        })
        if(flag==-1){
            setErrorMsg(t("지점")+t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        }else if(flag==-2){
            setErrorMsg(t("브랜드번호")+t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        }else if(flag==-3){
            setErrorMsg(t("브랜드명")+t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        }else if(flag==0){
            setConfirmMsg(t("등록하시겠습니까?"));
            handleConfirmOpen("post");
        }else if(flag==1){
            setConfirmMsg(t("정보를 수정하시겠습니까?")+" "+"["+modify.storeCd+"]");
            handleConfirmOpen("put");
        }else {
            setErrorMsg(t("이미 등록된 정보입니다"));
            handleErrorOpen();
        }
    }
    const handleDelete = async(arg) => {

        await deleteAPI(API.SYSTEM.STORE, {brandCd:arg.brandCd}).then((res) => {
            if (res.data.code === 200) {
                handleFormClose();
                onButtonClick("조회");
            } else {
                setErrorMsg(t("연결된 데이터가 존재하여 삭제되지 않았습니다."));
                handleErrorOpen();
            }
        });
    };
    return(
    <div className="main-container">
        <div className="header">
            <Grid container>
                <Grid item xs={10}>
                    {/* 상단메뉴명 */}
                    <UBreadCrumbs
                        title={"시스템관리"}
                        subtitle={"브랜드관리"}
                    />
                </Grid>
                <Grid item xs={2}>
                    {/* 툴바 버튼 */}
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="flex-start"
                        spacing={0.5}
                    >
                    </Stack>
                </Grid>
            </Grid>
        </div>

        <div className="contents">
            <Box>
                {/* 조회조건 */}
                <TableContainer className="table-container">
                <Table className="table"size="small">
                    <TableBody>
                        <TableRow className="table-row-header">
                            <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox
                                    name="bizTy"
                                    items={retailers}
                                    onItemChange={onSearchChange}
                                />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                            <TableCell className="table-cell">
                                {/* 점번선택 */}
                                <USelectBox
                                    name="storeCd"
                                    items={stores}
                                    onItemChange={onSearchChange}
                                    defaultValue={search.storeCd}
                                    />
                            </TableCell>
                            <TableCell className="table-cell-title">{fni18n('브랜드')}</TableCell>
                            <TableCell className="table-cell">
                                {/* 기번선택 */}
                                <USelectBox
                                    name="brandCd"
                                    items={brands}
                                    onItemChange={onSearchChange}
                                />
                            </TableCell>
                            <TableCell className="table-cell"></TableCell>
                            <TableCell className="table-cell"></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                </TableContainer>
                <div className="search">
                    <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
                </div>
            </Box>
            {/* 조회 리스트 */}
            <UTable 
                columns={columns} 
                rows={list}
                onSelectedRowChange={onSelectedRows}
                rowPerPage={11}
                toolbarAdd={
                    <UAuthButton icon="Add" menuFrom={location.pathname} onButtonClick={onButtonClick}>추가</UAuthButton>
                }
            />
        </div>
        <UConfirmDialog
            message={confirmMsg}
            open={confirmPopupOpen}
            onClose={handleConfirmClose}
            onClickOk={handelConfirmEvent}
        />
        <UAlertDialog
            message={errorMsg}
            open={errorPopupOpen}
            onClose={handleErrorClose}
        />
        {/* 팝업 */}
        <UPopupForm
            open={formOpen}
            onClose={handleFormClose}
            onSave={onSave}
            title='브랜드 설정'
            type={"2"}
            content={<StoreModify data={modify} onParamsChange={onModifyChange} onCheckboxChange={onCheckboxChange} />}
        /> 
    </div>
    );
}